import initGrabScroll from './initGrabScroll'

const partnersSection = document.querySelector('#partners-section')

if (partnersSection) {
	initGrabScroll(partnersSection)
}
